import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { pxToRem, size, width } from '@twistopayments/design-system/styles'

import patternImage from './pattern-background.svg'

export const header = (theme: Theme) => css`
  background-color: ${theme.palette.background.accent};

  padding: clamp(${size[64]}, ${size[56]} + 2vw, ${size[80]}) ${size[24]};
  position: relative;
`

export const headerPatternBackground = css`
  position: absolute;
  left: 0;
  top: 0;

  width: 100%;
  height: 100%;
  overflow: hidden;

  ::before,
  ::after {
    background: url(${patternImage}) no-repeat;
  }
  ::before {
    content: '';
    width: ${pxToRem(192)};
    height: ${pxToRem(192)};
    position: absolute;
    top: -${size[32]};
    left: calc(
      ((100vw - ${width.modal.compact}) / 2) - ${pxToRem(192)} - ${size[32]}
    );
    transform: rotate(-30deg);
  }

  ::after {
    content: '';
    width: ${pxToRem(117)};
    height: ${pxToRem(117)};
    position: absolute;
    bottom: -8px;
    right: calc(
      ((100vw - ${width.modal.compact}) / 2) - (${pxToRem(192)} + 9vw)
    );
    transform: rotate(120deg);
  }
`

export const headerContent = css`
  display: grid;
  grid-gap: ${size[40]};

  max-width: ${width.modal.compact};
  margin: 0 auto;

  isolation: isolate;
`

export const headline = css`
  font-size: ${pxToRem(48)};
  line-height: ${pxToRem(64)};
`
